import { FC } from 'react'
import { createPortal } from 'react-dom'
import { ChildrenProp } from '../../forms/hocs/types'

interface Props extends ChildrenProp {
    show: boolean
}

export const PortalComponent: FC<Props> = ({ show, children }) => {
    if (typeof document === 'undefined') {
        return null
    }

    const modalRootId = 'modal-root'

    if (!document.getElementById(modalRootId)) {
        const modalRoot = document.createElement('div')
        modalRoot.setAttribute('id', modalRootId)
        modalRoot.setAttribute('data-testid', modalRootId)
        document.body.appendChild(modalRoot)
    }

    const modalRootElement = document.getElementById(modalRootId)

    if (!show || !modalRootElement) {
        return null
    }

    return createPortal(children, modalRootElement)
}
